// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCE6RIUa7WZivuZauGuFRb7Gx3KLLA3qF8",
  authDomain: "piti-commerce.firebaseapp.com",
  databaseURL:
    "https://piti-commerce-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "piti-commerce",
  storageBucket: "piti-commerce.appspot.com",
  messagingSenderId: "254558078304",
  appId: "1:254558078304:web:8cd0ac67d9ff25b7ed8a05",
  measurementId: "G-93YNHPD18B",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
